import { useTranslation } from '@/core/hooks';
import { useQuery } from '@tanstack/react-query';
import { fetchVentures, fetchVentureById, VentureDetail, VentureListItem } from '../services/venturesService';

export function useVentures() {
    const { currentLanguage } = useTranslation();
    const locale = currentLanguage === 'ar' ? 'ar' : 'en';

    const query = useQuery<VentureListItem[]>({
        queryKey: ['ventures', locale],
        queryFn: () => fetchVentures(locale),
        staleTime: 5 * 60 * 1000,
    });

    return query;
}

export function useVenture(id?: string) {
    const { currentLanguage } = useTranslation();
    const locale = currentLanguage === 'ar' ? 'ar' : 'en';

    const query = useQuery<VentureDetail | null>({
        queryKey: ['venture', id, locale],
        queryFn: () => (id ? fetchVentureById(id, locale) : Promise.resolve(null)),
        enabled: !!id,
        staleTime: 5 * 60 * 1000,
    });

    return query;
}

